var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlog2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.19373 2.17578H2.87318C2.47001 2.17578 2.08336 2.33616 1.79827 2.62165C1.51319 2.90713 1.35303 3.29433 1.35303 3.69807V14.3541C1.35303 14.7578 1.51319 15.145 1.79827 15.4305C2.08336 15.716 2.47001 15.8763 2.87318 15.8763H13.5143C13.9175 15.8763 14.3041 15.716 14.5892 15.4305C14.8743 15.145 15.0344 14.7578 15.0344 14.3541V9.02606",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8943 1.03346C14.1967 0.730659 14.6068 0.560547 15.0345 0.560547C15.4621 0.560547 15.8722 0.730659 16.1746 1.03346C16.4769 1.33626 16.6468 1.74695 16.6468 2.17517C16.6468 2.6034 16.4769 3.01408 16.1746 3.31689L8.95383 10.5477L5.91351 11.3089L6.67359 8.26431L13.8943 1.03346Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog2);
export default __webpack_public_path__ + "static/media/blog2.c7c64e5414ad27c815fb1e4f2f87b340.svg";
export { ForwardRef as ReactComponent };